import { render, staticRenderFns } from "./UyapIlamBilgileriForm.vue?vue&type=template&id=79e9cd52&scoped=true"
import script from "./UyapIlamBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./UyapIlamBilgileriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9cd52",
  null
  
)

export default component.exports